import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Button from "material-ui/Button";

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: 128,
    alignItems: "center"
  },
  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },

  appBar: {
    backgroundColor: theme.palette.secondary["700"]
  },
  button: {
    marginTop: 50
  },
  instructions: {
    width: 750
  },
  instructions2: {
    width: 550
  }
});

const Redirecting = props => {
  const { url, title, buttonText, versionInfo, classes } = props;

  const onButton = () => {
    if (url) {
      window.location = url;
    }
  };

  if (url) {
    return (
      <div>
        <AppBar className={classes.appBar}>
          <Toolbar />
        </AppBar>

        <div className={classes.root}>
          <Typography type="body2" gutterBottom align="center">
            {versionInfo}
          </Typography>

          <Typography type="display3" gutterBottom align="center">
            {title}
          </Typography>

          <div className={classes.centered}>
            <Typography type="display1" gutterBottom align="center">
              Try refreshing the page, or click the button below to go to the
              onboarding app
            </Typography>

            <Button
              className={classes.button}
              raised
              color="accent"
              onClick={onButton}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <AppBar className={classes.appBar}>
          <Toolbar />
        </AppBar>

        <div className={classes.root}>
          <Typography type="body2" gutterBottom align="center">
            {versionInfo}
          </Typography>

          <Typography type="display3" gutterBottom align="center">
            {title}
          </Typography>

          <Typography type="display1" gutterBottom align="center">
            Can't proceed
          </Typography>
        </div>
      </div>
    );
  }
};

Redirecting.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  buttonText: PropTypes.string,
  versionInfo: PropTypes.string
};

Redirecting.defaultProps = {
  auto: true,
  buttonText: "go",
  destination: "another site"
};

export { Redirecting };

export default withStyles(styles, { name: "Redirecting" })(Redirecting);



// WEBPACK FOOTER //
// ./src/Redirecting.js